import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { If } from '../../components/ConditionalRendering';
import { isDefined, mascaraData, b64toBlob } from '../../util/Common';
import { Modal, Dimmer, Loader, Icon, Menu, Form, Grid, Segment, Header, Button, Input, Dropdown } from 'semantic-ui-react';
import Moment from 'moment';
import download from 'downloadjs';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import HttpService from '../../util/HttpService';
import * as LocalStorageManager from '../../util/StorageManager';

import 'react-datepicker/dist/react-datepicker.css';

class Relatorios extends Component {

    tipoArquivoOptions = [
        { key: 'pdf', text: 'PDF', value: 'pdf' },
        { key: 'xls', text: 'XLS', value: 'xls' }
    ]

    constructor(){
        super();
        this.state = {
            dataInicial: null,
            dataFinal: null,
			cliente: [],
            email: '',
            mensagem: '',
            tipoArquivo: 'pdf',
            relatorio: 'Listagem de Pedidos | Emitidos',
            enviarRelatorio: false,
			isLoading: false
        }
    }

	componentDidMount(){
		this.buscarClientes();
    }
    
	buscarClientes = () => {
		const user = LocalStorageManager.getLoggedUser();

		if(user.isCliente){
			// Seta o cliente selecionado como o proprio cliente logado
			this.setState({ cliente: [user.idt] })
		}else{
			HttpService.call(
				'sistema/combos',
				'clientes',
				[
					// idt do vendedor
					user.idt
				],
				(clientes) => this.setState({ clientes })
			);
		}
    }

    gerarRelatorio(){
        const { cliente, tipoArquivo, relatorio } = this.state;
        
		let dataInicial = Moment(this.state.dataInicial, 'DD/MM/YYYY');
        let dataFinal = Moment(this.state.dataFinal, 'DD/MM/YYYY');

        this.setState({ isLoading: true });
        
        HttpService.call(
			'consulta/documento',
			'gerarRelatorio',
			[
                LocalStorageManager.getOrigem().idt,
                cliente,
				dataInicial.isValid() ? dataInicial.format('YYYYMMDD') : '',
				dataFinal.isValid() ? dataFinal.format('YYYYMMDD') : '',
                tipoArquivo,
                relatorio,
                'PORTAL PEDIDOS LERROVILLE'
            ],
			(documento) => {
                this.setState({ isLoading: false })
                
				if(isDefined(documento)){
                    download(b64toBlob(documento.data, documento.mimeType), documento.filename, documento.mimeType);
				}
			}
        )
    }
    
    enviarRelatorio(){
        const { cliente, tipoArquivo, relatorio, email } = this.state;

        let dataInicial = Moment(this.state.dataInicial, 'DD/MM/YYYY');
        let dataFinal = Moment(this.state.dataFinal, 'DD/MM/YYYY');
        
        this.setState({ isLoading: true, enviarRelatorio: false });
        
        HttpService.call(
            'consulta/documento',
            'enviarRelatorio',
            [
                LocalStorageManager.getOrigem().idt,
                cliente,
				dataInicial.isValid() ? dataInicial.format('YYYYMMDD') : '',
				dataFinal.isValid() ? dataFinal.format('YYYYMMDD') : '',
                tipoArquivo,
                relatorio,
                'PORTAL PEDIDOS LERROVILLE',
                email
            ],
			(retorno) => {
                if(isDefined(retorno) && retorno.result){
                    toast.success('Relatório enviado com sucesso!')
                }else{
                    toast.error('Erro ao enviar relatório')
                }

                this.setState({ isLoading: false, email: '' })
            }
        )
    }

    handleChangeRelatorio = (e, { name }) => this.setState({ relatorio: name })

    render(){
        const { isLoading, relatorio, tipoArquivo, dataInicial, dataFinal, cliente, clientes } = this.state;

        return (
            <div>
                <Segment.Group className='white-background'>
                    <Segment>
                        <Header>Relatórios</Header>
                    </Segment>
                    <Segment.Group>
                        <Segment size='mini' attached='top' secondary>
                            <Grid>
                                <Grid.Column mobile={16} tablet={6} computer={4} stretched>
                                    <Menu fluid vertical tabular stackable>
                                        <Menu.Item>
                                            <Menu.Header>
                                                <Segment vertical>
                                                    <Icon name='file text'/>
                                                    Tipo de relatório
                                                </Segment>
                                            </Menu.Header>
                                            <Menu.Item name='Listagem de Pedidos | Emitidos' active={relatorio === 'Listagem de Pedidos | Emitidos'} onClick={this.handleChangeRelatorio} />
                                            <Menu.Item name='Listagem de Vendas | Por Vendedores' active={relatorio === 'Listagem de Vendas | Por Vendedores'} onClick={this.handleChangeRelatorio} />
                                            <Menu.Item name='Listagem de Vendas | Por Clientes' active={relatorio === 'Listagem de Vendas | Por Clientes'} onClick={this.handleChangeRelatorio} />
                                            <Menu.Item name='Listagem de Vendas | Sintético' active={relatorio === 'Listagem de Vendas | Sintético'} onClick={this.handleChangeRelatorio} />
                                        </Menu.Item>
                                    </Menu>
                                </Grid.Column>
                                <Grid.Column mobile={16} tablet={10} computer={12} stretched>
                                    <Segment>
                                        <Dimmer active={ isLoading } inverted>
                                            <Loader inverted>Carregando</Loader>
                                        </Dimmer>
                                        <Form size='tiny'>
                                            <If test={LocalStorageManager.getLoggedUser().isCliente}>
                                                <Form.Field width={16}>
                                                    <label>Cliente</label>
                                                    <Input disabled value={ LocalStorageManager.getLoggedUser().nome } />
                                                </Form.Field>
                                            </If>
                                            <If test={!LocalStorageManager.getLoggedUser().isCliente}>
                                                <Form.Field width={16} control={Dropdown} label='Cliente'
                                                        fluid search multiple selection selectOnBlur={false}
                                                        placeholder='Nome do cliente' 
                                                        noResultsMessage='Nenhum resultado encontrado' 
                                                        value={cliente}
                                                        options={clientes}
                                                        loading={clientes === undefined}
                                                        onChange={(e, { value }) => this.setState({ cliente: value })}/>
                                            </If>
                                            <Form.Group>
                                                <Form.Field width='5' required control={DatePicker} label='Data Inicial' selected={dataInicial} maxDate={dataFinal} onChange={(dataInicial) => this.setState({ dataInicial })} onChangeRaw={(event) => event.target.value = mascaraData(event.target.value)} />
                                                <Form.Field width='5' required control={DatePicker} label='Data Final' selected={dataFinal} minDate={dataInicial} onChange={(dataFinal) => this.setState({ dataFinal })} onChangeRaw={(event) => event.target.value = mascaraData(event.target.value)} />
                                            </Form.Group>
                                            <Form.Field width='3' control={Dropdown} label='Formato'
                                                        fluid selection 
                                                        value={tipoArquivo}
                                                        options={ this.tipoArquivoOptions }
                                                        onChange={(e, { value }) => this.setState({ tipoArquivo: value})}/>
                                        </Form>
                                    </Segment>
                                </Grid.Column>                                    
                            </Grid>
                        </Segment>
                        <Segment size='mini' clearing attached='bottom'>
                            <Button primary content='Enviar' floated='right' icon='envelope' onClick={ () => this.setState({ enviarRelatorio: true }) } disabled={ this.state.dataInicial === '' || this.state.dataFinal === '' }/>
                            <Button secondary content='Visualizar' floated='right' icon='eye' onClick={ this.gerarRelatorio.bind(this) } disabled={ this.state.dataInicial === '' || this.state.dataFinal === '' }/>
                            <Button negative content='Fechar' floated='left' icon='window close' onClick={() => this.props.history.push('/main')} />                    
                        </Segment>
                    </Segment.Group>
                </Segment.Group>
                <Modal size='tiny' open={this.state.enviarRelatorio}>
                    <Modal.Header>
                        Enviar relatório por email
                    </Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Field control={Input} label='Email' placeholder='Ex.: exemplo@email.com.br' value={ this.state.email } onChange={(event) => this.setState({ email: event.target.value })}/>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative content='Fechar' floated='left' icon='window close' onClick={ () => this.setState({ enviarRelatorio: false }) } />                    
                        <Button primary content='Enviar' icon='envelope' onClick={ this.enviarRelatorio.bind(this) } disabled={ this.state.dataInicial === '' || this.state.dataFinal === '' }/>
                    </Modal.Actions>
                </Modal>
            </div>
        )
    }
}

export default withRouter(Relatorios)


// WEBPACK FOOTER //
// ./src/views/Relatorios/index.js